import anime from "animejs";
import React, { useEffect, useRef } from "react";

export default function Loading({ text }) {
    const logoRef = useRef(null);
    const ringsRef = useRef(null);
    const dotsRef = useRef([]);

    useEffect(() => {
        anime({
            targets: logoRef.current?.querySelector("span"),
            scale: ["0.8", "1.4"],
            opacity: [1, 0],
            easing: "easeOutCubic",
            duration: 1500,
            loop: true,
        });

        anime({
            targets: ringsRef.current?.querySelectorAll(".loading-ring"),
            scale: [1, 2],
            opacity: [0.4, 0],
            easing: "easeOutCubic",
            duration: 2400,
            loop: true,
            delay: anime.stagger(600),
        });

        anime({
            targets: dotsRef.current,
            translateY: [-8, 0],
            opacity: [0.2, 1],
            easing: "easeInOutSine",
            duration: 650,
            loop: true,
            direction: "alternate",
            delay: anime.stagger(200),
        });
    }, []);

    return (
        <section className="table-section_empty pt-6">
            <div className="relative flex items-center justify-center mb-6" style={{ width: 220, height: 220, margin: "0 auto" }}>
                <div ref={ringsRef} className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="loading-ring absolute rounded-full border-2 border-brand/40" style={{ width: 180, height: 180 }} />
                    <div className="loading-ring absolute rounded-full border-2 border-brand/25" style={{ width: 200, height: 200 }} />
                </div>

                <div ref={logoRef} className="img-table_wrapper loading stopped">
                    <div className="absolute inset-0 backdrop-blur-md bg-white/10 rounded-full z-0" />
                    <img
                        src="/identity/MONOLOGO.png"
                        alt="Loader Mono"
                        width="199px"
                        height="143px"
                        className="relative z-10"
                    />
                    <span className="background-gradient" />
                </div>
            </div>

            <div className="flex items-center justify-center gap-2 mb-4">
                {[0, 1, 2].map((i) => (
                    <div
                        key={i}
                        ref={(el) => (dotsRef.current[i] = el)}
                        className="w-2.5 h-2.5 rounded-full"
                        style={{ backgroundColor: "#ff1e01" }}
                    />
                ))}
            </div>

            {text && (
                <h2 className="text-white text-xl font-semibold text-center px-6 leading-snug font-display">
                    {text}
                </h2>
            )}
        </section>
    );
}
